<template>
  <div class="meal-reservation">
    <!-- 顶部tab -->
    <!-- <div class="page-header">
      <van-tabs v-model:active="state.activeTab" type="card" @click-tab="onTabChange">
        <van-tab title="套餐订单" :name="0" />
        <van-tab title="饮品订单" :name="1" />
    </van-tabs>
    </div> -->
    
    <!-- 预约列表 -->
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.isFinish"
        finished-text="没有更多了"
        @load="getReservationList"
      >
        <div class="reservation-list" v-if="state.activeTab == 0">
          <div class="list-item" v-for="(item, index) in state.reservationList" :key="index">
            <div class="item-top" @click="goToDetail(item)">
              <span class="item-time">{{ formateDate(item.plannedDiningTime) }}  {{item.orgName}}</span>
              <span class="status-tag" :class="getStatusClass(item)">
                {{ item.statusDesc }}  
              </span>
            </div>
            <div class="item-middle" @click="goToDetail(item)">
              <div class="meal-name">
                <span class="meal-period">{{ formateMealPeriod(item.mealPeriod) }}：{{ item.mealPackage }}</span>
                
                <span class="amount">¥{{ item.payMoney || '0' }}</span>
                
              </div>
              <div class="meal-sub">
                <span class="address-text">{{ item.deliveryAddress }}</span>
                <span style="font-size: 12px;margin-right: 6px;">共{{ item.quantity }}件</span>
              </div>
            </div>
            <div class="item-bottom">
              
              
              <div class="actions">
                <van-button size="small" plain hairline class="btn cancel-btn" @click="handleRefund(item)" v-if="item.payStatus == 2 && item.status == 0 && canOperateOrder(item)">申请退款</van-button>
                <van-button size="small" plain hairline class="btn cancel-btn" @click="handleCancel(item)" v-if="item.payStatus == 7 && canOperateOrder(item)">取消订单</van-button>
                <van-button size="small" plain hairline class="btn pay-btn" @click="handlePay(item)" v-if="item.payStatus == 7 && canOperateOrder(item)">支付</van-button>
              </div>
            </div>
          </div>
          <div v-if="state.reservationList.length === 0 && !state.loading" style="text-align: center; padding: 50px 0; color: #999;">暂无数据</div>
          <EmptyDataCard style="margin-top: 88px" v-show="!state.reservationList.length && !state.loading" />
        </div>
        <div class="reservation-list" v-if="state.activeTab == 1">
          <div class="list-item" v-for="(item, index) in state.reservationList" :key="index">
            <!-- 状态标签 -->
            <div class="status-tag" :class="'status-tag-1-' + item.status">
              {{ getStatusDrinkText(item.status) }}
            </div>
            <div class="item-header">
              <div class="location">{{ item.deliveryAddress }}</div>
            </div>
            
            <div class="item-content">
              <div style="display: flex; justify-content: space-between; width: 100%; align-items: flex-start;">
                  <div class="drink-info-list">
                  <div class="drink-info-row" v-for="(d, idx) in item.detailList" :key="idx">
                    <span class="drink-name">{{ d.drinkName }}</span>
                    <span v-if="d.iceLevel" class="drink-spec">-{{ getIceLevelName(d.iceLevel) }}</span>
                    <span class="drink-qty">×{{ d.quantity }}</span>
                  </div>
                </div>
                <div class="drink-top-summary-row">
                  <span class="drink-amount">￥{{ item.totalAmount }}</span>
                  <span class="drink-count">共{{ item.detailList && item.detailList.length ? item.detailList.reduce((sum, d) => sum + (d.quantity || 0), 0) : 0 }}杯</span>
                </div>
              </div>
              
              <div class="drink-bottom-row">
                <div class="drink-time">{{ item.plannedDeliveryTime ? item.plannedDeliveryTime.slice(0, 16).replace('T', ' ') : '-' }}</div>
                <div v-if="item.status == 0" class="item-footer btn-row">
                  <van-button 
                    size="small" 
                    type="default" 
                    class="footer-btn cancel-btn"
                    @click="handleCancelDrink(item)"
                  >取消</van-button>
                  <van-button 
                    size="small" 
                    type="primary" 
                    class="footer-btn edit-btn"
                    @click="handleEditDrink(item)"
                  >编辑</van-button>
                </div>
              </div>
              
            </div>
          </div>
          <EmptyDataCard
            style="margin-top: 88px"
            v-show="!state.reservationList.length && !state.loading"
          />
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- 底部预约按钮 -->
    <!-- <div class="bottom-button">
      <van-button type="primary" class="reserve-btn" @click="handleReserve">立即预约</van-button>
    </div> -->
  </div>
</template>

<script>
import { defineComponent, reactive, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { showDialog, showNotify } from 'vant'
import EmptyDataCard from '@/components/EmptyDataCard.vue'
import { getMealReservationList, refundOrder, cancelMealReservation, querySyDrinkPageList, updateStatusSyDrinkReservation, payMealReservation } from '@/api/meal'
import dayjs from 'dayjs'
import { postSyparamSelectList } from "@/api/report";
import { queryGetEnum } from "@/api/user";


export default defineComponent({
  name: 'MealReservation',
  
  components: {
    EmptyDataCard
  },

  setup() {
    const route = useRoute();
    const router = useRouter()
    const state = reactive({
      reservationList: [],
      loading: false,
      refreshing: false,
      page: {
        pageIndex: 1,
        pageSize: 10
      },
      isFinish: false,
      userId: null,
      openId: null,
      realName: null,
      phone: null,
      limitTime: '11:00',
      activeTab: 0, // 0:套餐订单 1:饮品订单
      lunchTPlus: 0,
      lunchBigDesc: '09:00',
      dinnerTPlus: 0,
      dinnerBigDesc: '15:00',
      configUpdateTime: 0,
      limitTimeInfo :[]
    })

    const isCustomer = ref(1);

    const formateDate = (date) => {
        return dayjs(date).format('YYYY-MM-DD')
    }

    const iceLevelEnum = ref([]);
    const drinkStatusEnum = ref({});
    // 获取冰度枚举
    const getIceLevelEnum = async () => {
      const result = await queryGetEnum({ enumName: "IceLevelEnum" });
      for (let i in result.data) {
        iceLevelEnum.value = result.data;
      }
    };
    // 获取饮品订单状态枚举
    const getDrinkStatusEnum = async () => {
      const result = await queryGetEnum({ enumName: "DrinkReservationStatusEnum" });
      if (result && result.data) {
        drinkStatusEnum.value = result.data;
      }
    };
    const getIceLevelName = (id) => iceLevelEnum.value[id];
    // 动态获取饮品订单状态文案
    const getStatusDrinkText = (status) => {
      return drinkStatusEnum.value[status] || status;
    }

     // 获取支付状态枚举
     const payStatusEnum = ref({});

    const getPaytatusEnum = async () => {
      const result = await queryGetEnum({ enumName: "PayStatusEnum" });
      if (result && result.data) {
        payStatusEnum.value = result.data;
      }
    };

    // 获取套餐订单状态枚举
    const mealStatusEnum = ref({});

    const getMealStatusEnum = async () => {
      const result = await queryGetEnum({ enumName: "MealReservationStatusEnum" });
      if (result && result.data) {
        mealStatusEnum.value = result.data;
      }
    };

    const getStatusText = (item) => {
      if (item.payStatus == 2 || !item.payStatus) {
        return mealStatusEnum.value[item.status] || item.statusDesc
      }
      return payStatusEnum.value[item.payStatus] || item.payStatusDesc || '待支付'
    }

    // 根据支付状态和预约状态获取样式类名
    const getStatusClass = (item) => {
        // 根据预约状态返回样式
        const statusClassMap = {
          0: 'status-paid',       // 待送餐 - 绿色
          1: 'status-paid',      // 已送餐 - 绿色
          2: 'status-refunded',  // 已取消 - 灰色
          3: 'status-waiting'    // 待支付 - 黄色
        }
        return statusClassMap[item.status] || 'status-pay'
    }

    const formateMealPeriod = (mealPeriod) => {
        const mealPeriodText = {
            1: '早餐',
            2: '午餐',
            3: '晚餐',
            4: '夜宵'
          }
        return mealPeriodText[mealPeriod]
    }

    // 获取预约列表数据
    const getReservationList = async () => {
      try {
        state.loading = true
        let result
        if (state.activeTab === 0) {
          result = await getMealReservationList({
            page: {
              ...state.page
            },
            userId: state.userId
          })
        } else {
          result = await querySyDrinkPageList({
            page: {
              ...state.page
            },
            userId: state.userId
          })
        }
        state.loading = false
        if (result.code === '00') {
          if (state.refreshing) {
            state.reservationList = result.data.list
          } else {
            state.reservationList = [...state.reservationList, ...result.data.list]
          }
          if (state.page.pageIndex >= result.data.pages) {
            state.isFinish = true
          } else {
            state.page.pageIndex++
          }
        } else {
          // showNotify({ type: 'warning', message: result.message })
        }
      } catch (error) {
        state.loading = false
        state.isFinish = true // 防止接口报错时死循环加载
        console.error('获取预约列表失败:', error)
        // showNotify({ type: 'danger', message: '获取预约列表失败' })
      }
    }

    // 跳转详情页
    const goToDetail = (item) => {
      if(!item.orderNo) {
        return
      }
      router.push({
        path: '/meal/customer-reservation-detail',
        query: {
          orderNo: item.orderNo,
          userId: state.userId,
          openId: state.openId
        }
      })
    }

    // tab切换
    const onTabChange = ({name}) => {
      console.log('onTabChange', name)
      state.activeTab = Number(name)
      state.page.pageIndex = 1
      state.isFinish = false // 切换tab时允许重新加载
      state.reservationList = []
      getReservationList()
    }

    // 判断是否允许操作预约
    const canOperateReservation = (plannedDiningTime) => {
      const now = dayjs();
      const today = now.startOf('day');
      // 解析 state.limitTime（格式如 '11:00'）
      const [limitHour, limitMinute] = state.limitTime.split(':').map(Number);
      const limitTime = today.add(limitHour, 'hour').add(limitMinute || 0, 'minute');
      const plannedDate = dayjs(plannedDiningTime).startOf('day');
      const diffDays = plannedDate.diff(today, 'day');
      if (now.isBefore(limitTime)) {
        // 限定时间前，只能操作明天及以后
        return diffDays >= 1;
      } else {
        // 限定时间后，只能操作后天及以后
        return diffDays >= 2;
      }
    }

    // 判断是否允许退款/取消（基于餐次和截止时间）
    const canRefundOrCancel = (item) => {
      const now = dayjs();
      const plannedDate = dayjs(item.plannedDiningTime).startOf('day');
      
      // 午餐：截止时间为当天09:00
      if (item.mealPeriod == 2) {
        const deadline = plannedDate.add(9, 'hour');
        if (now.isAfter(deadline)) {
          showNotify({ type: 'warning', message: '已超过午餐退款截止时间（当天09:00）' });
          return false;
        }
      }
      // 晚餐：截止时间为当天15:00
      if (item.mealPeriod == 3) {
        const deadline = plannedDate.add(15, 'hour');
        if (now.isAfter(deadline)) {
          showNotify({ type: 'warning', message: '已超过晚餐退款截止时间（当天15:00）' });
          return false;
        }
      }
      return true;
    }

    // 判断是否允许操作订单（申请退款、取消订单、支付按钮是否显示）
    const canOperateOrder = (item) => {
      getConfigPayTimeLimit(item)
      const now = dayjs();
      const today = now.startOf('day');
      const plannedDate = dayjs(item.plannedDiningTime).startOf('day');
      const diffDays = plannedDate.diff(today, 'day');

      // 客户模式：code=2 午餐，code=3 晚餐
      if (item.mealPeriod == 2) {
          // 午餐：limitDate = 今天 + lunchTPlus 天
          const tPlus = state.lunchTPlus;
          const [hour, minute] = state.lunchBigDesc.split(':').map(Number);
          const limitDate = today.add(tPlus, "day");
          const limitTime = today.add(hour, 'hour').add(minute, 'minute');

          console.log("午餐判断:", {
            今天: today.format("YYYY-MM-DD"),
            选择日期: plannedDate.format("YYYY-MM-DD"),
            diffDays,
            tPlus,
            limitDate: limitDate.format("YYYY-MM-DD"),
            limitTime: limitTime.format("YYYY-MM-DD HH:mm"),
            now: now.format("YYYY-MM-DD HH:mm"),
            isBeforeLimit: now.isBefore(limitTime)
          });

          if (diffDays < tPlus) {
            return false;
          }
          if (diffDays == tPlus) {
            return now.isBefore(limitTime);
          }
          return true;
        } else if (item.mealPeriod == 3) {
          // 晚餐：limitDate = 今天 + dinnerTPlus 天
          const tPlus = state.dinnerTPlus;
          const [hour, minute] = state.dinnerBigDesc.split(':').map(Number);
          const limitDate = today.add(tPlus, "day");
          const limitTime = today.add(hour, 'hour').add(minute, 'minute');

          console.log("晚餐判断:", {
            今天: today.format("YYYY-MM-DD"),
            选择日期: plannedDate.format("YYYY-MM-DD"),
            diffDays,
            tPlus,
            limitDate: limitDate.format("YYYY-MM-DD"),
            limitTime: limitTime.format("YYYY-MM-DD HH:mm"),
            now: now.format("YYYY-MM-DD HH:mm"),
            isBeforeLimit: now.isBefore(limitTime)
          });

          if (diffDays < tPlus) {
            return false;
          }
          if (diffDays == tPlus) {
            return now.isBefore(limitTime);
          }
          return true;
        }

    }

    // 下拉刷新
    const onRefresh = async () => {
      state.refreshing = true
      state.page.pageIndex = 1
      state.isFinish = false // 下拉刷新时允许重新加载
      await getReservationList()
      state.refreshing = false
    }

    const handleCancelDrink = (item) => {
      console.log('handleCancelDrink', item)
      showDialog({
        title: '取消预约',
        message: '确定要取消该预约吗？',
        showCancelButton: true
      }).then(async () => {
        try {
          const result = await updateStatusSyDrinkReservation({
            id: item.id,
            status: 3
          })
          if (result.code === '00') {
            showNotify({ type: 'success', message: '取消预约成功' })
            onRefresh()
          } else {
            showNotify({ type: 'warning', message: result.message })
          }
        } catch (error) {
          console.error('取消预约失败:', error)
          showNotify({ type: 'danger', message: '取消预约失败' })
        }
      }).catch(() => {
        console.log('取消')
      })
    }
    const handleEditDrink = (item) => {
      router.push({
        path: '/drink-menu',
        query: {
          editData: encodeURIComponent(JSON.stringify(item)),
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    const handleCancel = (item) => {
      if (!canRefundOrCancel(item)) {
        return
      }
      showDialog({
        title: '取消预约',
        message: '确定要取消该预约吗？',
        showCancelButton: true
      }).then(async () => {
        try {
          const result = await cancelMealReservation({
            id: item.id
          })
          if (result.code === '00') {
            showNotify({ type: 'success', message: '取消预约成功' })
            onRefresh()
          } else {
            showNotify({ type: 'warning', message: result.message })
          }
        } catch (error) {
          console.error('取消预约失败:', error)
          showNotify({ type: 'danger', message: '取消预约失败' })
        }
      }).catch(() => {
        console.log('取消')
      })
    }

    const handleEdit = (item) => {
      if (!canOperateReservation(item.plannedDiningTime)) {
        showNotify({ type: 'warning', message: '当前该预约不可操作，请在允许的时间段内操作' })
        return
      }
      router.push({
        path: '/meal/edit',
        query: {
          id: item.id,
          info: JSON.stringify(item),
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    // 支付
    const handlePay = (item) => {
      showDialog({
        title: '确认支付',
        message: `确定要支付订单吗？金额：￥${item.payMoney || '0'}`,
        showCancelButton: true
      }).then(async () => {
        try {
          const JsonData = JSON.stringify({
            ...item,
            money: item.payMoney
          });

          window.wx.miniProgram.navigateTo({url: `/pages/payment/paymentResult?JsonData=${JsonData}`})
        } catch (error) {
          console.error('支付失败:', error)
          showNotify({ type: 'danger', message: '支付失败' })
        }
      }).catch(() => {
        console.log('取消')
      })
    }

    // 退款
    const handleRefund = (item) => {
      if (!canRefundOrCancel(item)) {
        return
      }
      showDialog({
        title: '确认退款',
        message: '确定要申请退款吗？',
        showCancelButton: true
      }).then(async () => {
        try {
          const result = await refundOrder({
            orderNo: item.orderNo,
            userId: state.userId,
            openId: state.openId,
            refundAmount: Number(item.payMoney) * 100
          })
          if (result.code === '00') {
            showNotify({ type: 'success', message: '退款申请已提交' })
            onRefresh()
          } else {
            showNotify({ type: 'warning', message: result.message })
          }
        } catch (error) {
          console.error('退款失败:', error)
          showNotify({ type: 'danger', message: '退款失败' })
        }
      }).catch(() => {
        console.log('取消')
      })
    }

    const handleReserve = () => {
      router.push({
        path: '/meal/reserve',
        query: {
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    onMounted(() => {
      if(route?.query?.token) {
        localStorage.setItem('token', route?.query?.token)
      }
      if(route?.query?.userId) {
        state.userId = route?.query?.userId
      }
      if(route?.query?.openId) {
        state.openId = route?.query?.openId
      }
      if(route?.query?.realName) {
        state.realName = route?.query?.realName
      }
      if(route?.query?.phone) {
        state.phone = route?.query?.phone
      }

      if(route?.query?.type) {
        state.activeTab = Number(route?.query?.type ?? 0)
      }
      getReservationList()
      gettimeLimit()
      getIceLevelEnum()
      getDrinkStatusEnum()
      getPaytatusEnum()
      getMealStatusEnum()
    })

    const handleExclusiveRecipe = () => {
      router.push({
        path: '/meal/exclusive-recipe',
        query: {
          userId: state.userId,
          realName: state.realName,
          phone: state.phone,
        }
      })
    }

    const getConfigPayTimeLimit = (item) => {
      let orgData = state.limitTimeInfo.filter(item => item.createOrg == item.orgId);
      // 如果没有匹配到，使用默认值
      if (orgData.length === 0) {
              state.lunchTPlus = 0;
              state.lunchBigDesc = '09:00';
              state.dinnerTPlus = 0;
              state.dinnerBigDesc = '15:00';
              state.configUpdateTime = Date.now();
            } else {
              const lunchItem = orgData.find(item => item.code == 2);
              const dinnerItem = orgData.find(item => item.code == 3);
              state.lunchTPlus = lunchItem ? parseInt(lunchItem.value) : 0;
              state.lunchBigDesc = lunchItem?.bigDesc ?? '09:00';
              state.dinnerTPlus = dinnerItem ? parseInt(dinnerItem.value) : 0;
              state.dinnerBigDesc = dinnerItem?.bigDesc ?? '15:00';
              state.configUpdateTime = Date.now();
            }
    }

    const gettimeLimit = async () => {
      // 获取送餐地点选项
      try {
        if (isCustomer.value == 1) {
          // 客户模式：获取午餐和晚餐的 T+ 时间
          const res = await postSyparamSelectList({ bigCode: "userPayTimeLimit" });
          if (res && Array.isArray(res.data)) {
            // 根据校区ID过滤数据（同时尝试字符串和数字匹配）
            // 注意：客户模式下使用默认校区配置
            state.limitTimeInfo = res.data;
          }
        } else {
          const res = await postSyparamSelectList({ bigCode: "timeLimit" });
          if (res && Array.isArray(res.data)) {
            state.limitTime = res.data[0]?.bigDesc ?? '11:00'
          }
        }
      } catch (e) {
        if (isCustomer.value == 1) {
          state.lunchTPlus = 0;
          state.lunchBigDesc = '09:00';
          state.dinnerTPlus = 0;
          state.dinnerBigDesc = '15:00';
          state.configUpdateTime = Date.now();
        } else {
          state.limitTime = '11:00'
        }
      }
    };

    return {
      state,
      getStatusText,
      handleCancel,
      handleEdit,
      handleReserve,
      onRefresh,
      formateDate,
      formateMealPeriod,
      handleExclusiveRecipe,
      getReservationList,
      canOperateReservation,
      onTabChange,
      iceLevelEnum,
      getIceLevelName,
      getStatusDrinkText,
      drinkStatusEnum,
      getDrinkStatusEnum,
      handleCancelDrink,
      handleEditDrink,
      handlePay,
      handleRefund,
      getStatusClass,
      payStatusEnum,
      mealStatusEnum,
      getMealStatusEnum,
      goToDetail,
      canOperateOrder
    }
  }
})
</script>

<style lang="scss" scoped>
.meal-reservation {
  min-height: 100vh;
  background: #f2f2f2;
  padding: 12px;

  .reservation-list {
    .list-item {
      background: #fff;
      border-radius: 10px;
      margin-bottom: 12px;
      overflow: hidden;
      cursor: pointer;

      .item-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 14px;
        background:linear-gradient(160deg, #013152 0%, #014370 50%, #85bbee 100%) !important;

        color: #fff;

        .item-time {
          font-size: 14px;
          font-weight: 500;
        }

        .status-tag {
          padding: 4px 10px;
          border-radius: 10px;
          font-size: 12px;
          background: rgba(255, 255, 255, 0.3);

          &.status-0 { background: rgba(255, 151, 106, 0.9); }
          &.status-1 { background: rgba(7, 193, 96, 0.9); }
          &.status-2 { background: rgba(150, 151, 153, 0.9); }
          &.status-pay { background: rgba(255, 255, 255, 0.3); }
          &.status-pending { background: rgba(255, 146, 46, 0.9); }    // 待支付 - 橙色
          &.status-paid { background: rgba(7, 193, 96, 0.9); }         // 绿色
          &.status-refunding { background: rgba(25, 137, 250, 0.9); } // 退费中 - 蓝色
          &.status-refunded { background: rgba(150, 151, 153, 0.9); } // 灰色
          &.status-refund-fail { background: rgba(245, 58, 58, 0.9); } // 退费失败 - 红色
          &.status-waiting { background: rgba(255, 151, 106, 0.9); }    // 待支付 - 黄色
        }
      }

      .item-middle {
        padding: 14px;

        .meal-name {
          font-size: 16px;
          color: #1a1a1a;
          font-weight: 600;
          margin-bottom: 8px;
          display: flex;
          justify-content: space-between;
          
          .meal-period {
            color: #1989fa;
            margin-right: 6px;
          }
        }

        .meal-sub {
          font-size: 13px;
          color: #999;
          display: flex;
          justify-content: space-between;
          
          .address-text {
            // margin-left: 12px;
          }
        }
      }

      .item-bottom {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 14px 14px;
        border-top: 1px solid #f0f0f0;

        .amount {
          flex: 1;
          font-size: 18px;
          color: #ff4d4f;
          font-weight: 600;
        }

        .actions {
          display: flex;
          gap: 12px;
        }

        .btn {
          height: 32px;
          border-radius: 6px;
          font-size: 13px;
          padding: 0 18px;
          font-weight: 500;
        }
        .pay-btn {
          background:linear-gradient(160deg, #013152 0%, #014370 50%, #85bbee 100%) !important;
          color: #fff !important;
          border: none !important;
          box-shadow: 0 2px 8px rgba(25, 137, 250, 0.3);
        }
        .pay-btn:active {
          opacity: 0.9;
          transform: scale(0.98);
        }
        .cancel-btn {
          background: #fff !important;
          color: #666 !important;
          border: 1px solid #dcdee0 !important;
        }
        .cancel-btn:active {
          background: #f5f5f5 !important;
        }
      }
    }
  }
}

.page-header {
  padding: 12px;
  margin: 0 68px;
}

.drink-info-list {
  width: 100%;
  margin-bottom: 8px;
  .drink-info-row {
    font-size: 16px;
    color: #2F8ED4;
    margin-bottom: 2px;
    text-align: left;
    .drink-name {
      font-weight: 500;
    }
    .drink-spec {
      margin-left: 4px;
      color: #888;
      font-size: 14px;
    }
    .drink-qty {
      margin-left: 8px;
      font-weight: 500;
    }
  }
}
.drink-top-summary-row {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  margin: 6px 0 2px 0;
  font-size: 16px;
  .drink-amount {
    color: #000;
    font-size: 17px;
    font-weight: 500;
    margin-right: 16px;
  }
  .drink-count {
    color: #888;
    font-size: 15px;
    margin-top: 2px;
    margin-bottom: 4px;
  }
}
.drink-bottom-row {
  display: flex;
  justify-content:space-between;
  align-items: center;
  font-size: 15px;
  color: #888;
  margin-bottom: 0;
  width: 100%;
  .drink-time {
    color: #888;
    font-size: 15px;
  }
}
</style> 